<template>
  <v-app class="overHidden">
    <router-view />
    <!-- <go-top
      :size="50"
      :bottom="50"
      :right="1150"
      bg-color="#20DB9D"
    ></go-top
  > -->
  </v-app>
</template>
<script type="text/javascript">
// import GoTop from "@inotom/vue-go-top";
export default {
  name: "App",
  components: {
    // GoTop,
  },
  data: () => ({
    //
  }),
};
!(function () {
  var i = "dD6Wia",
    a = window,
    d = document;
  function g() {
    var g = d.createElement("script"),
      s = "https://www.goftino.com/widget/" + i,
      l = localStorage.getItem("goftino_" + i);
    (g.async = !0), (g.src = l ? s + "?o=" + l : s);
    d.getElementsByTagName("head")[0].appendChild(g);
  }
  "complete" === d.readyState
    ? g()
    : a.attachEvent
    ? a.attachEvent("onload", g)
    : a.addEventListener("load", g, !1);
})();
</script>
<style>
@font-face {
  font-family: Vazir;
  src: url(./assets/font/Vazir.woff2);
}
@font-face {
  font-family: Bvazir;
  src: url(./assets/font/Vazir-Bold.woff2);
}
@font-face {
  font-family: digit;
  src: url(./assets/font/Vazir-Black-FD-UI.woff2);
}
* {
  font-family: digit, vazir;
}
.widget-icon {
  background: rgb(2, 14, 15) !important;
}
.blue-text {
  color: #3c56c8 !important;
}
.fffcolor {
  color: #fff !important;
}
.blue-bcg {
  background-color: #3c56c8 !important;
}
.block {
  display: block !important;
}
.brown-text {
  color: #775100 !important;
}
.gray-text {
  color: #707070 !important;
}
.pointer {
  cursor: pointer !important;
}
.b1 {
  font-family: Bvazir !important;
  /* font-weight: 900 !important; */
}
.b2 {
  font-weight: 700 !important;
}
.b3 {
  font-weight: 500 !important;
}
.Ldiraction {
  direction: ltr !important;
}
.link {
  color: #000 !important;
  text-decoration: none !important;
}
.link:hover {
  color: #3c56c8 !important;
  transition: 0.3s;
}
.gray-bcg {
  background-color: #fbfbfb;
}
.green-circle {
  border-radius: 50%;
  width: 66px;
  height: 66px;
  line-height: 400%;
  color: #fff;
  background-color: #20db9d;
}
.text-small {
  font-size: 11px;
  height: 1.3em;
}
.text-smaller {
  font-size: 10px;
}
.font-large {
  font-size: 3em !important;
}
.btn-radio {
  border-radius: 2em 2em !important;
}
.noty_body {
  direction: rtl !important;
}
.relative {
  position: relative;
}
.border {
  border: solid 1px #575757;
}
.border-dark {
  border: solid 1px #707070;
}
.font14 {
  font-size: 14px;
}
.block {
  display: block !important;
}
.none {
  display: none !important;
}
.scrollX {
  overflow-x: auto;
}
.justify {
  text-align: justify;
  text-justify: inter-word;
}
.green-bcg {
  background-color: #2a9d8f !important;
}
.orangeBcg{
  background-color: orange !important;
}
.blue-border {
  border: 1px solid #3c56c8;
}
.red-text {
  color: #e76f51 !important;
}
.red-border {
  border: 1px solid #e76f51 !important;
}
.light-blue-border {
  border: 0.5px solid #3c56c8;
}
.vh60 {
  min-height: 60vh;
}
.vh70 {
  min-height: 70vh;
}
.white-bcg {
  background-color: white;
}
.bcg-none {
  background-color: rgba(255, 255, 255, 0) !important;
}
.light-bcg {
  background-color: #d2d2d2 !important;
}
.font19 {
  font-size: 19px !important;
}
.font23 {
  font-size: 23px !important;
}
.overHidden {
  overflow: hidden;
}
.disable {
  cursor: not-allowed !important;
  pointer-events: none !important;
  
}
</style>
